require('./bootstrap')
require('select2')
require('owl.carousel')
require('lightbox2')

$(document).ready(function () {
    // homepage search select
    $('.sc-search').select2({
        placeholder: 'Your location',
        theme: 'bootstrap4',
    })

    // partner carousel
    $('.partner-carousel').owlCarousel({
        autoplay: true,
        autoplayTimeout: 1500,
        autoplayHoverPause: true,
        loop: true,
        margin: 60,
        responsive: {
            0: {
                items: 2
            },
            600: {
                items: 4
            },
            1000: {
                items: 6
            }
        }
    });
})
